var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-truncate"},[_c('v-btn',{attrs:{"flat":"","large":"","loading":_vm.loading},on:{"click":function($event){return _vm.ConfirmLeistung();}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(!_vm.hasLeistung ? 'check_box_outline_blank' :  'check_box'))]),_vm._v("\n    "+_vm._s(_vm.leistung.leistung)+"\n  ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }